import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Categories = lazy(() => import('../pages/categories/page'));
const Cart = lazy(() => import('../pages/cart/page'));
const Orders = lazy(() => import('../pages/orders/page'));
const Profile = lazy(() => import('../pages/profile/page'));
const Wishlist = lazy(() => import('../pages/wishlist/page'));
const Vendor = lazy(() => import('../pages/vendor/page'));
const Courier = lazy(() => import('../pages/courier/page'));
const Notifications = lazy(() => import('../pages/notifications/page'));
const Addresses = lazy(() => import('../pages/addresses/page'));
const PaymentMethods = lazy(() => import('../pages/payment-methods/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const LoginPage = lazy(() => import('../pages/login/page'));
const SecurityPage = lazy(() => import('../pages/security/page'));
const LanguagePage = lazy(() => import('../pages/language/page'));
const HelpSupportPage = lazy(() => import('../pages/help-support/page'));
const StoryEditorPage = lazy(() => import("../pages/story-studio/page"));
const ProductDetailPage = lazy(() => import('../pages/product/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const PaymentPage = lazy(() => import('../pages/payment/page'));
const StorePage = lazy(() => import('../pages/store/page'));
const CampaignPage = lazy(() => import('../pages/campaign/page'));
const CampaignItemPage = lazy(() => import('../pages/campaign/item/page'));
const SupermarketPage = lazy(() => import('../pages/supermarket/page'));
const AllStoresPage = lazy(() => import('../pages/stores/page'));
const SearchResultsPage = lazy(() => import('../pages/search/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const SupportPage = lazy(() => import('../pages/support/page'));
const MarketerPage = lazy(() => import('../pages/marketer/page'));

const routes: RouteObject[] = [
  {
    path: '/admin/*',
    element: <AdminPage />,
  },
  {
    path: '/support',
    element: <SupportPage />,
  },
  {
    path: '/marketer',
    element: <MarketerPage />,
  },
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/supermarket',
    element: <SupermarketPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/categories',
    element: <Categories />,
  },
  {
    path: '/product/:id',
    element: <ProductDetailPage />,
  },
  {
    path: '/store/:id',
    element: <StorePage />,
  },
  {
    path: '/campaign/:campaignId/item/:itemId',
    element: <CampaignItemPage />,
  },
  {
    path: '/campaign/:id',
    element: <CampaignPage />,
  },
  {
    path: '/stores',
    element: <AllStoresPage />,
  },
  {
    path: '/search',
    element: <SearchResultsPage />,
  },
  {
    path: '/cart',
    element: <Cart />,
  },
  {
    path: '/orders',
    element: <Orders />,
  },
  {
    path: '/profile',
    element: <Profile />,
  },
  {
    path: '/wishlist',
    element: <Wishlist />,
  },
  {
    path: '/vendor',
    element: <Vendor />,
  },
  {
    path: '/courier',
    element: <Courier />,
  },
  {
    path: '/notifications',
    element: <Notifications />,
  },
  {
    path: '/addresses',
    element: <Addresses />,
  },
  {
    path: '/payment-methods',
    element: <PaymentMethods />,
  },
  {
    path: '/security',
    element: <SecurityPage />
  },
  {
    path: '/language',
    element: <LanguagePage />
  },
  {
    path: '/terms',
    element: <TermsPage />
  },
  {
    path: '/privacy',
    element: <PrivacyPage />
  },
  {
    path: '/payment',
    element: <PaymentPage />
  },
  {
    path: '/help-support',
    element: <HelpSupportPage />
  },
  {
    path: "/story-studio",
    element: <StoryEditorPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;